import { render, staticRenderFns } from "./Cowviewdetails.vue?vue&type=template&id=7e437430&"
import script from "./Cowviewdetails.vue?vue&type=script&lang=js&"
export * from "./Cowviewdetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports